import type { UserAccountProps } from 'utils/types';
import { useCeDirectoryAvailability } from '../../../features/ceDirectory';
import { isDentistRecordEligibleForCeDirectory } from './accessPolicy';

export type OfficeCeDirectoryAccess = {
  user: UserAccountProps | null;
  userId: number | null;
  eligible: boolean;
  availability: boolean | null;
  enabled: boolean;
};

const getSessionUser = (): UserAccountProps | null => {
  try {
    return (window as any)?.TempStars?.User?.getCurrentUser?.() || null;
  } catch {
    return null;
  }
};

/**
 * One React consumer of T2-6820's session-wide runtime availability seam.
 * The shared hook owns the explicit-flag/probe/cache/event state machine.
 */
export const useOfficeCeDirectoryAccess = (): OfficeCeDirectoryAccess => {
  const user = getSessionUser();
  const eligible = isDentistRecordEligibleForCeDirectory(user);
  const userId = eligible ? Number(user?.id) : null;
  const availability = useCeDirectoryAvailability(userId);

  return {
    user,
    userId,
    eligible,
    availability,
    enabled: eligible && availability === true,
  };
};
